// extracted by mini-css-extract-plugin
export var aircallIframe = "_fs-3";
export var fabContainer = "_fs-5";
export var fabRinging = "_fs-6";
export var loadingOverlay = "_fs-4";
export var pulse = "_fs-7";
export var widgetContent = "_fs-2";
export var widgetPanel = "_fs-0";
export var widgetPanelExpanded = "_fs-1";